module.exports = __webpack_public_path__ + "static/img/futizhi.5618c32c.png";